import { render, staticRenderFns } from "./manage-evolution.html?vue&type=template&id=82f6b61a&scoped=true&external"
import script from "./manage-evolution.js?vue&type=script&lang=js&external"
export * from "./manage-evolution.js?vue&type=script&lang=js&external"
import style0 from "./manage-evolution.scss?vue&type=style&index=0&id=82f6b61a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f6b61a",
  null
  
)

export default component.exports